import React from 'react';
import { Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookiesPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#ECEC75] via-[#e6e67c] to-[#ECEC75] py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-black rounded-full mb-6">
            <Cookie size={40} className="text-[#D4AF37]" />
          </div>
          <h1 className="text-5xl font-bold text-black mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
            Politique des Cookies
          </h1>
          <p className="text-xl text-black/70">
            Comment nous utilisons les cookies
          </p>
        </div>

        {/* Content */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 md:p-12 space-y-8">
          <div className="prose prose-lg max-w-none">
            <div className="p-6 bg-[#D4AF37]/10 rounded-xl mb-8">
              <h3 className="text-xl font-bold text-black mb-2">Qu'est-ce qu'un cookie ?</h3>
              <p className="text-black/70">
                Un cookie est un petit fichier texte stocké sur votre appareil lors de votre visite sur notre site.
                Les cookies nous aident à améliorer votre expérience de navigation.
              </p>
            </div>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">Types de cookies utilisés</h2>
              
              <div className="space-y-4">
                <div className="p-6 border-l-4 border-[#D4AF37] bg-black/5 rounded-r-lg">
                  <h4 className="font-bold text-black mb-2">🔧 Cookies essentiels</h4>
                  <p className="text-black/70 mb-2">Nécessaires au fonctionnement du site.</p>
                  <p className="text-sm text-black/60">Exemple : gestion des sessions, préférences de langue</p>
                </div>

                <div className="p-6 border-l-4 border-[#D4AF37] bg-black/5 rounded-r-lg">
                  <h4 className="font-bold text-black mb-2">📊 Cookies analytiques</h4>
                  <p className="text-black/70 mb-2">Nous aident à comprendre comment vous utilisez notre site.</p>
                  <p className="text-sm text-black/60">Exemple : pages visitées, temps passé sur le site</p>
                </div>

                <div className="p-6 border-l-4 border-[#D4AF37] bg-black/5 rounded-r-lg">
                  <h4 className="font-bold text-black mb-2">🎯 Cookies de performance</h4>
                  <p className="text-black/70 mb-2">Améliorent les performances et la personnalisation.</p>
                  <p className="text-sm text-black/60">Exemple : préférences d'affichage, localisation</p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">Gestion des cookies</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Vous pouvez contrôler et gérer les cookies de plusieurs façons :
              </p>
              <ul className="list-disc list-inside space-y-2 text-black/80 ml-4">
                <li>Via les paramètres de votre navigateur</li>
                <li>En refusant les cookies lors de votre première visite</li>
                <li>En supprimant les cookies existants</li>
              </ul>
              <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <p className="text-sm text-amber-900">
                  ⚠️ Attention : Bloquer tous les cookies peut affecter votre expérience sur le site.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">Durée de conservation</h2>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="p-4 bg-black/5 rounded-lg">
                  <h4 className="font-bold text-black mb-2">Cookies de session</h4>
                  <p className="text-sm text-black/70">Supprimés à la fermeture du navigateur</p>
                </div>
                <div className="p-4 bg-black/5 rounded-lg">
                  <h4 className="font-bold text-black mb-2">Cookies persistants</h4>
                  <p className="text-sm text-black/70">Conservés jusqu'à 12 mois maximum</p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">Contact</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Pour toute question sur notre utilisation des cookies :
              </p>
              <div className="p-6 bg-black text-white rounded-xl">
                <p className="font-bold mb-2">Le Cosmos Tacos</p>
                <p>49 Av. de la Libération, 42000 Saint-Étienne</p>
                <p>Tél : 04 87 66 22 41</p>
              </div>
            </section>
          </div>
        </div>

        {/* Back Button */}
        <div className="text-center mt-8">
          <Link
            to="/"
            className="inline-block bg-black text-white px-8 py-3 rounded-lg font-semibold hover:bg-black/90 transition-colors"
          >
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicy;
